import { Box, Button, ButtonProps, Tooltip } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

interface FloatingActionButtonsProps {
  children: React.ReactNode
}

type FloatingActionButtonProps = PropsWithChildren<ButtonProps & { title: string }>

const FloatingActionButton: FC<FloatingActionButtonProps> = ({
  onClick,
  color = 'primary',
  children,
  title,
}) => {
  return (
    <Tooltip placement="right" title={title}>
      <Button
        color={color}
        size="large"
        sx={{
          minWidth: '48px',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          boxShadow: 3,
        }}
        variant="contained"
        onClick={onClick}
      >
        {children}
      </Button>
    </Tooltip>
  )
}

const FloatingActionButtonsComponent: FC<FloatingActionButtonsProps> & {
  Button: typeof FloatingActionButton
} = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: '10px',
        top: '100px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {children}
    </Box>
  )
}

FloatingActionButtonsComponent.Button = FloatingActionButton

export const FloatingActionButtons = FloatingActionButtonsComponent
